import AttendanceListRow from './AttendanceListRow'

export default AttendanceListRow
